<ng-template #vista [ngIf]="modoVisualizacion==='vista'">
  <div class={{classMargen}} class="image-container">
    <div class="image-filter"></div>
    <img class="image-crop" [src]="imageUrl" width="100%">
    <div class="container in-image">
      <h1 class="display-3 text-white title-font-banner">{{titulo}}</h1>
      <p class="text-white">{{descripcion}}</p>
      <p *ngIf="botonTitulo"><a class="btn btn-primary btn-lg" routerLink={{botonRuta}} role="button">{{botonTitulo}}
          &raquo;</a></p>
    </div>
  </div>
</ng-template>

<ng-template #edicion [ngIf]="modoVisualizacion==='edicion'">
  <div class={{classMargen}} class="image-container">
    <div class="image-filter"></div>
    <img class="image-crop" [src]="imageUrl" width="100%">

    <div class="container in-image">

      <div class="col-md-6 offset-md-3">
        <input type="file" id="boton-imagen" hidden accept=".jpg,.png,.jpeg" (change)="getImage($event)"/>
        <label id="boton-imagen-label" for="boton-imagen">
          <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-upload" fill="currentColor"
            xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd"
              d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z" />
            <path fill-rule="evenodd"
              d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708l3-3z" />
          </svg>
          Elige imagen del tour
        </label>

        <div class="input-group input-group-lg">
          <input type="text" class="form-control text-center" placeholder="Título del tour" [(ngModel)]="titulo"
            aria-label="Titulo del tour" aria-describedby="basic-addon2">
        </div>
        <div class="input-group input-group-sm">
          <input type="text" class="form-control text-center" placeholder="Descripción del tour" [(ngModel)]="descripcion"
            aria-label="Descripción del tour" aria-describedby="basic-addon2">
        </div>

        
      </div>

      <div *ngIf="showSelector==true" class="row pt-2">
        <div class="col-md-4">
          <app-selector-ubicacion mensajeSeleccion="Selecciona un continente" [options]="continentes" (selected)="getPaises($event)" [selectedValue]="selectedContinent"></app-selector-ubicacion>
        </div>
        <div class="col-md-4">
          <app-selector-ubicacion mensajeSeleccion="Selecciona un pais" [options]="paises" (selected)="getCiudades($event)" [selectedValue]="selectedCountry"></app-selector-ubicacion>
        </div>
        <div class="col-md-4">
          <app-selector-ubicacion mensajeSeleccion="Selecciona una ciudad" [options]="ciudades" (selected)="selectedCity=$event" [selectedValue]="selectedCity"></app-selector-ubicacion>
        </div>
      </div>

      <!-- <h1 class="display-3">{{titulo}}</h1>
        <p>{{contenido}}</p>
        <p *ngIf="botonTitulo"><a class="btn btn-primary btn-lg" routerLink={{botonRuta}} role="button">{{botonTitulo}}
            &raquo;</a></p>  -->
    </div>

    
  </div>


</ng-template>